import styled from '@emotion/styled';
import React, { ReactElement, useState } from 'react';
import { OL_LANGUAGE_KEY } from '../../i18n/constants';
import { SingleSelect } from '../Input/Dropdowns/SingleSelect';
import { ValueLabelPair } from '../Input/Dropdowns/SingleSelect/types';
import { LANGUAGES } from './constants';

const StyledSelect = styled(SingleSelect)({
  width: '56px',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  paddingLeft: 4,
  borderLeftColor: 'rgba(0, 0, 0, 0)',
  borderRightColor: 'rgba(0, 0, 0, 0)',
  borderLeftWidth: '1px',
  borderRightWidth: '1px',
  borderLeftStyle: 'solid',
  borderRightStyle: 'solid',

  '&:hover': {
    borderColor: 'rgba(0, 0, 0, 0.25)',
    background: 'rgba(0, 0, 0, 0.04) !important',

    '.react-selectize-control, .react-selectize-control div, .react-selectize-control input': {
      background: 'rgba(0, 0, 0, 0) !important',
    },
  },

  '.react-selectize.root-node': {
    width: '100%',
  },

  '.react-selectize.default.root-node .react-selectize-control.react-selectize-control.react-selectize-control': {
    padding: '0px !important',
    border: 'none !important',
  },

  '.value-wrapper': {
    minWidth: 'initial !important',
  },

  '.dropdown-menu.default.react-selectize.simple-select': {
    width: '164px !important',
  },
});

export const ChooseLanguageSelect = ({
  currentLanguage = window.localStorage.getItem(OL_LANGUAGE_KEY),
  onSave,
}: {
  currentLanguage?: string | null;
  onSave: (language: string) => void;
}): ReactElement => {
  const currentOption = {
    ...(LANGUAGES.find((lan) => lan.value === currentLanguage) || LANGUAGES[0]),
  };
  currentOption.label = currentOption.value.toUpperCase();
  const [language, setLanguage] = useState(currentOption);
  const onChange = (selection?: ValueLabelPair): void => {
    if (selection) {
      const selectedLanguage = {
        ...selection,
        label: selection.value.toUpperCase(),
      };
      setLanguage(selectedLanguage);
      onSave(selection.value);
    }
  };

  return (
    <StyledSelect
      aria-label={language.ariaLabel}
      className=""
      label=""
      value={language}
      options={LANGUAGES}
      onValueChange={onChange}
    />
  );
};
